import SoftwareDevelopmentLogo from "../assets/icons8-software-development-96.png";
import SoftwareTestingLogo from "../assets/icons8-software-testing-96.png";
import MLLogo from "../assets/icons8-machine-learning-96.png";
import FrontendDeveloperLogo from "../assets/icons8-frontend-developer-96.png";

const ServiceData = [
  {
    id: "id",
    service_name: "Software Development",
    service_description:
      "Skills to develope highly scalable, efficient and well-documented applications from scratch.",
    service_logo: SoftwareDevelopmentLogo
  },
  {
    id: "id",
    service_name: "Software Testing",
    service_description:
      "Ability to built functionality tests, find and resolve bugs, and automate tests.",
    service_logo: SoftwareTestingLogo
  },
  {
    id: "id",
    service_name: "ML models",
    service_description:
      "Efficency in understanding and building machine learning models to solve mordern problems.",
    service_logo: MLLogo
  },
  {
    id: "id",
    service_name: "Front-end development",
    service_description:
      "Embitious to make the UI appealing, Responsive and user-friendly.",
    service_logo: FrontendDeveloperLogo
  }
];

export default ServiceData;
